export default "__VITE_ASSET__Cglu07TK__"